import { render, staticRenderFns } from "./PointMgmt.vue?vue&type=template&id=4fe98ade&scoped=true"
import script from "./PointMgmt.vue?vue&type=script&lang=js"
export * from "./PointMgmt.vue?vue&type=script&lang=js"
import style0 from "./PointMgmt.vue?vue&type=style&index=0&id=4fe98ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe98ade",
  null
  
)

export default component.exports